fx.ns("requests", class AIRequest extends fx.Service
{
    constructor(data)
    {
        super();

        this.model = data;

        this.PROCESS_TIMEOUT = 20000;

        this.endpoint = this.model.servers.aiServers.getItemAt(0).url + "/v2/photo";
        
        this._currentPhoto = null;
    }

    get currentPhoto()
    {
        return this._currentPhoto;
    }

    get photoIds()
    {
        return this.model.photos.filter(photo => photo.faces).map(photo => photo.temporaryId);
    }

    // ------------- Anayse Photo ------------------//

    analysePhoto(photo)
    {
        this._currentPhoto = photo;

        try 
        {
            var formData = new FormData();
            
            if(this._currentPhoto.base64)
            {
                formData.append('file', /base64,(.+)/.exec(this._currentPhoto.base64)[1]);
                formData.append('base64', true);
            }
            else
            {
                formData.append('url', this._currentPhoto.thumb);
                formData.append('base64', false);
            }
            
            formData.append('id_photo', this._currentPhoto.temporaryId);
            formData.append('date', this._currentPhoto.date_takenSQL || this._currentPhoto.date_taken || this._currentPhoto.date);
            formData.append('bookid', this.model.creation.id);
            formData.append('width', this._currentPhoto.width);
            formData.append('height', this._currentPhoto.height);
            formData.append('latitude', this._currentPhoto.latitude);
            formData.append('longitude', this._currentPhoto.longitude);
            
            this.post(formData, this._photoAnalysed, {processData: false,  contentType: false, maxTries : 1, timeout : this.PROCESS_TIMEOUT  });   
            
            this.trigger("photo-analyse-started", this);
        }
        catch(e)
        {
            this._photoAnalysed({error : true});
        }
    }

   

    // ------------------------- Privates -------------------------- //

    _photoAnalysed(data)
    {
        if (!this._currentPhoto || typeof this._currentPhoto.setFaces != "function") // https://my.trackjs.com/details/889959d56ef94ec9a132897d9648d43b
            this.trigger("photo-analyse-error", this);
        else
        if (data.error)
        {
            this._currentPhoto.setFaces({faces : []});
            this.trigger("photo-analyse-error", this);
        }
        else
        {
            this._currentPhoto.setFaces(data);
            this._currentPhoto.prop("base64", undefined);
            this._currentPhoto = null;
            this.trigger("photo-analyse-finished", this);
        }
    }


});
    